package br.com.vvrefeicoes.portal.core.util.file

class PickedFile(
    val name: String,
    val bytes: ByteArray,
    val contentType: String = "application/octet-stream",
)

/** `true` quando a plataforma implementa o envio de PDF (hoje só no Web). */
expect fun isPdfUploadSupported(): Boolean

/** Abre o seletor de PDF da plataforma. Retorna `null` se cancelar ou não suportar. */
expect suspend fun pickPdfFile(): PickedFile?
